import { useMemo } from 'react';
import { useSelectedPrimaryImage } from '~/hooks/image/useSelectedImages';
import { useComparisonImages } from '~/hooks/viewer/useComparisonImages';

export function usePlaceableFramesOfReference(): ReadonlySet<string> {
    const primaryImage = useSelectedPrimaryImage();
    const compared = useComparisonImages();

    return useMemo(() => {
        const frames = new Set<string>();
        for (const image of [primaryImage, ...compared]) {
            if (image && !image.isSpatiallyResampled) {
                frames.add(image.frameOfReferenceUid);
            }
        }
        return frames;
    }, [primaryImage, compared]);
}
